import { render, staticRenderFns } from "./AreaChart.vue?vue&type=template&id=b1746dcc&"
import script from "./AreaChart.vue?vue&type=script&lang=js&"
export * from "./AreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports